import { Main } from "../Styles/Global.Styled";
import Landing from "../Components/Sections/Landing";
import FeatureProducts from "../Components/Sections/FeatureProducts";
import ProcessSection from "../Components/Sections/ProccessSection";
import SectionType1 from "../Components/Sections/SectionType1";
import SectionType2 from "../Components/Sections/SectionType2";
import aboutUsHome from "../assets/Images/aboutUsHome.jpg";
import bgHomeSection from "../assets/Images/bgHomeSection.jpeg";

const aboutUsContent = {
  id: "who-we-are",
  header: "About Fresh Flowers Supply",
  subHeader: "Your trusted partner in floral excellence for over three decades",
  paragraph: (
    <>
      Nestled in the heart of Naaldwijk, the Netherlands, our journey in the
      wholesale floristry business began over 30 years ago. With a passion for
      delivering the freshest and most exquisite blooms to our clients, we have
      dedicated ourselves to providing unparalleled quality and service
      throughout our decades-long history.
      <br />
      <br />
      Established in 1991, we take pride in our rich heritage as a family-owned
      wholesale florist company. From our humble beginnings, we have grown to
      become a cornerstone in the floral industry, supplying our exceptional
      products to clients spanning the entire Middle East. Our commitment to
      quality, reliability, and unmatched service has been the driving force
      behind our success.
    </>
  ),
  img: aboutUsHome,
  cta: "Read more",
  url: "/about-us",
  flexD: "row",
  bgColor: true,
};
const signUpContent = {
  id: "join-us",
  header: "Become a Partner",
  paragraph: `Join us as a partner to access specialized tools for quote request
        tracking and order management. Enhance your experience and grow your
        business with our streamlined partnership program.`,
  img: bgHomeSection,
  cta: "Join us",
  url: "/register",
  color: "white",
  fontSize: "L",
};

const Home = () => {
  return (
    <Main>
      <Landing />
      <FeatureProducts />
      <SectionType1 content={aboutUsContent} />
      <ProcessSection />
      <SectionType2 content={signUpContent} />
    </Main>
  );
};

export default Home;
